//import './modules/scrollTop';
//
import './modules/map';
import './modules/fitty';
import './modules/swiper';
import './modules/menu';
import './modules/svg4everybody';
import './modules/photoswipe';
import './modules/bg-change';

//import './modules/inViewport';
//import './modules/ieparallaxbugfix';





// WEBPACK FOOTER //
// ./assets/src/js/index.js